import React from 'react'
import { Table, TableBody, TableHead, TableRow } from '@material-ui/core'
import { get } from 'lodash'
import clsx from 'clsx'
import { round } from '../../../../helpers'
import Graph from './Graph'

import { useStyles, StyledTableRow, StyledTableCell } from '../styles'


export default function ReportTable(props) {
    const classes = useStyles()

    return (
        <div className={classes.reportTableContainer}>
            <Table id="organisation-compensation-report" className={classes.reportTable} size="small">
                <TableHead>
                    <TableRow>
                    <StyledTableCell className={classes.noBorder}></StyledTableCell>
                        {
                            props.groups.map(group =>
                                <React.Fragment key={group}>
                                    <StyledTableCell className={classes.noBorder}></StyledTableCell>
                                    <StyledTableCell
                                        className={classes.bgWhite}
                                        colSpan={3+props.extraFields.length}
                                    >
                                        {props.groupsNames[group]}
                                    </StyledTableCell>
                                </React.Fragment>
                            )
                        }
                    </TableRow>
                    <TableRow>
                        <StyledTableCell className={classes.bgBlack}>
                            Hierarchy
					</StyledTableCell>
                        {
                            props.groups.map(group =>
                                <React.Fragment key={group}>
                                    <StyledTableCell className={classes.noBorder}></StyledTableCell>
                                    <StyledTableCell
                                        className={classes.bgBlueGrey}
                                        colSpan={2}
                                    >
                                        {'Job Title'}
                                    </StyledTableCell>
                                    <StyledTableCell className={classes.bgBlueGrey}>
                                        n
								</StyledTableCell>
                                    {
                                        props.extraFields.map((field, i) =>
                                            <StyledTableCell key={i} className={classes.bgBlueGrey}>
                                                {props.extraFiledTitles[field]}
                                            </StyledTableCell>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        props.levelsData.map((levelData, i) => {
                            return (
                                <StyledTableRow key={i}>
                                    <StyledTableCell className={classes.bgBlack}>
                                        {i}
                                    </StyledTableCell>
                                    {
                                        props.groups.map(group => {
                                            const groupLevelData = levelData[group]
                                            const level = get(groupLevelData, 'level', '')
                                            return (
                                                <React.Fragment key={`${i}${group}`}>
                                                    <StyledTableCell className={classes.noBorder}></StyledTableCell>
                                                    <StyledTableCell className={level ? classes.bgBlack : classes.bgWhite}>
                                                        {get(groupLevelData, 'level', '')}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={clsx(classes.leftJustified, level ? classes.bgBlack : classes.bgWhite)}>
                                                        {get(groupLevelData, 'title', '')}
                                                    </StyledTableCell>
                                                    <StyledTableCell className={level ? classes.bgLightBlue : classes.bgWhite}>
                                                        {get(groupLevelData, 'n', '')}
                                                    </StyledTableCell>
                                                    {
                                                        get(groupLevelData, 'extraFieldsValues', Array(props.extraFields.length).fill('')).map((value, k) =>
                                                            <StyledTableCell key={`gld${k}`} className={level ? classes.bgLightBlue : classes.bgWhite}>
                                                                {value ? round(value,2).toFixed(2) : ''}
                                                            </StyledTableCell>
                                                        )
                                                    }
                                                </React.Fragment>
                                            )
                                        })
                                    }
                                </StyledTableRow>
                            )
                        })
                    }
                    <StyledTableRow>
                        <StyledTableCell className={classes.noBorder}></StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                        <StyledTableCell className={classes.bgLightGreen}>Total {props.currentTotalN}</StyledTableCell>
                        {
                            props.groups.map(group =>
                                <React.Fragment key={group}>
                                    <StyledTableCell className={classes.noBorder} colSpan={3}></StyledTableCell>
                                    <StyledTableCell className={classes.bgLightGreen}>
                                        {get(props.groupSummary[group], 'n', '')}
                                    </StyledTableCell>
                                    {
                                        props.extraFields.length !== 0 ?
                                            <StyledTableCell className={classes.noBorder} colSpan={props.extraFields.length}></StyledTableCell>
                                            :
                                            null
                                    }
                                </React.Fragment>
                            )
                        }
                    </StyledTableRow>
                    <StyledTableRow>
                    <StyledTableCell className={classes.noBorder}></StyledTableCell>

                        {
                            props.groups.map((group, j) => {
                                let forReverse = props.graphsDataByGrades[group]
                                return (
                                    <React.Fragment key={`${j}${group}`}>
                                        <StyledTableCell className={classes.noBorder}></StyledTableCell>
                                        <StyledTableCell colSpan={props.extraFields.length + 3} className={classes.noBorder}>
                                            <Graph key={`gg${j}`}
                                                data={forReverse.reverse()}
                                                vAxisTitle={'Job Level'}
                                                type={'LineChart'}
                                                // width={props.extraFields.length * 175}
                                            />
                                        </StyledTableCell>
                                    </React.Fragment>
                                )}
                            )
                        }
                    </StyledTableRow>

                    {/* {
					props.showGraphs ?
						<>
							<StyledTableRow className={classes.emptyRow}>
							</StyledTableRow>
							<StyledTableRow>
								<StyledTableCell className={classes.noBorder}></StyledTableCell>
								{
									props.groups.map((group, j) =>
										<StyledTableCell key={`gg${j}`} className={classes.noBorder} colSpan={props.extraFields.length + 3}>
											<Graph
												data={graphsDataByGrades[group]}
											/>
										</StyledTableCell>
									)
								}
							</StyledTableRow>
						</>
						:
						null
				} */}

                </TableBody>
            </Table>
        </div>
    )
}
